import { Grid, Typography } from "@mui/material"
export interface CompanyGeneralStatsProps {
    userInfo: {
        paidUsers: number,
        activeUsers: number,
    }
    completionStats: {
        totalCompleteSessions: number,
        totalPartialSessions: number,
        totalUnusableSessions: number,
    },
    typeStats: {
        localSessions: number,
        remoteSessions: number,
        tweenScreen: number,
        tScreen: number,
    },
    dataStats: {
        crises: number,
    }
}
export default function CompanyGeneralStats({ userInfo, completionStats, typeStats, dataStats }: CompanyGeneralStatsProps) {
    return (
        <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={6}>
                <Typography>Paid Users</Typography>
                <Typography>{userInfo.paidUsers}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Active Users</Typography>
                <Typography>{userInfo.activeUsers}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Total Complete Sessions</Typography>
                <Typography>{completionStats.totalCompleteSessions}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Partial Sessions</Typography>
                <Typography>{completionStats.totalPartialSessions}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Abandoned Sessions</Typography>
                <Typography>{completionStats.totalUnusableSessions}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Local Sessions</Typography>
                <Typography>{typeStats.localSessions}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Remote Sessions</Typography>
                <Typography>{typeStats.remoteSessions}</Typography>
            </Grid>
            {/* TODO: MOVE THIS SOMEWHERE ELSE */}
            <Grid size={6}>
                <Typography>TweenScreen Sessions</Typography>
                <Typography>{typeStats.tweenScreen}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>tScreen Sessions</Typography>
                <Typography>{typeStats.tScreen}</Typography>
            </Grid>
            <Grid size={6}>
                <Typography>Total Crises</Typography>
                <Typography>{dataStats.crises}</Typography>
            </Grid>
        </Grid>
    )
}